import { Component, OnInit, Inject } from "@angular/core";
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from "@angular/material/legacy-dialog";
import { DialogData } from "@app/shared/models/dialog-data";
import { ConfirmModalComponent } from "@app/shared/dialogs/confirm-dialog/confirm-modal.component";

type CreateUserDialogData = DialogData & {
  email: string;
  userCode: string;
};

@Component({
  selector: "app-user-create-dialog",
  templateUrl: "./user-create-dialog.component.html",
  styleUrls: ["./user-create-dialog.component.scss"],
})
export class UserCreateDialogComponent
  extends ConfirmModalComponent
  implements OnInit
{
  public email: string;
  public userCode: string;

  constructor(
    public dialogRef: MatDialogRef<UserCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateUserDialogData
  ) {
    super(dialogRef, data);
    this._idPrefix = "create_user_dialog.";
  }

  public ngOnInit() {
    super.ngOnInit();
    //this.email = this.data.email;
    this.userCode = this.data.userCode;
  }

  public accept(): void {
    this.dialogRef.close({ email: this.email, userCode: this.userCode });
  }
}
